export const formatDiffValue = (value: any) => {
  let formatted = value;
  if (typeof value === 'boolean') {
    formatted = value ? 'On' : 'Off';
  }
  return formatted.charAt(0) + formatted.slice(1).toLowerCase();
};
